import { debug, george, observer, pr, React, RouteComponentProps, ui } from "aaa";
import { observable } from "mobx";
import { pushRoute } from "stores/RouterFunctions";
import { SettingsTitleBar } from "../components/SettingsTitleBar";
import { SIdentitySettingsRoutes } from "./SIdentitySettingsRoutes";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";

type IProps = RouteComponentProps<{}> & {
    store: SIdentitySettingsStore
};

@observer
export class SIdentitySettingsAddDeviceSummary extends React.Component<IProps, {}> {
    @observable approved = false;
    @observable loading = false;

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    onActivate = async () => {
        try {
            this.loading = true;
            await this.props.store.addDevice();
            pushRoute(SIdentitySettingsRoutes.ADD_DEVICE_SIGNING);
            this.loading = false;
        } catch (error) {
            debug.log("### error starting activation", JSON.stringify(error, null, 4));
            this.loading = false;
            pushRoute("/error");
        }
    }

    renderSummary() {
        return (
            <george.CardSectionContent>
                <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                <pr.SigningLabel>
                    {ui.__("sidentitySettings.addDevice.summary")}
                </pr.SigningLabel>
                <br />

                <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>
                <br />
            </george.CardSectionContent>
        );
    }

    render() {
        return (
            <>
                <SettingsTitleBar backRoute={SIdentitySettingsRoutes.ROOT}><pr.H1_16_FFFFFF>{ui.__("sidentitySettings.navbar.addDevice")}</pr.H1_16_FFFFFF></SettingsTitleBar>
                <george.BackgroundWithNavBar>
                    <george.PageWithActionButton>
                        <george.Card>
                            <george.CardSectionTitle title={ui.__("sidentity.summary.title")} />
                            {this.renderSummary()}
                        </george.Card>
                        <george.ActionButton
                            primary
                            messageId="button.continue"
                            isLoading={this.loading}
                            onClick={this.onActivate}
                        />
                    </george.PageWithActionButton>
                </george.BackgroundWithNavBar>
            </>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsAddDeviceSummary.tsx